const propertyActions = {

  DO_GET_PROPERTY_VIEWING_PREFERENCES: 'DO_GET_PROPERTY_VIEWING_PREFERENCES',
  DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS: 'DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS',
  DO_GET_PROPERTY_VIEWING_PREFERENCES_FAILED: 'DO_GET_PROPERTY_VIEWING_PREFERENCES_FAILED',
  doGetPropertyViewingPreferences: hash => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES,
    payload: hash
  }),
  doGetPropertyViewingPreferencesSuccess: response => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS,
    payload: response
  }),
  doGetPropertyViewingPreferencesFailed: response => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES_FAILED,
    payload: response
  }),

  DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE: 'DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE',
  DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_SUCCESS: 'DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_SUCCESS',
  DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_FAILED: 'DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_FAILED',
  doGetPropertyViewingPreferencesSingle: hash => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE,
    payload: hash
  }),
  doGetPropertyViewingPreferencesSingleSuccess: response => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_SUCCESS,
    payload: response
  }),
  doGetPropertyViewingPreferencesSingleFailed: response => ({
    type: propertyActions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_FAILED,
    payload: response
  }),

  DO_RESET_PROPERTY_VIEWING_PREFERENCE_FAILED: 'DO_RESET_PROPERTY_VIEWING_PREFERENCE_FAILED',
  doResetPropertyViewingPreferenceFailed: () => ({
    type: propertyActions.DO_RESET_PROPERTY_VIEWING_PREFERENCE_FAILED
  }),
  
  DO_DELETE_PROPERTY_VIEWING_PREFERENCE: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE',
  DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SUCCESS: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SUCCESS',
  DO_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED',
  doDeletePropertyViewingPreference: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE,
    payload
  }),
  doDeletePropertyViewingPreferenceSuccess: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SUCCESS,
    payload
  }),
  doDeletePropertyViewingPreferenceFailed: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED,
    payload
  }),

  DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE',
  DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS',
  DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED: 'DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED',
  doDeletePropertyViewingPreferenceSingle: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE,
    payload
  }),
  doDeletePropertyViewingPreferenceSingleSuccess: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS,
    payload
  }),
  doDeletePropertyViewingPreferenceSingleFailed: payload => ({
    type: propertyActions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED,
    payload
  }),

  DO_RESET_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED: 'DO_RESET_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED',
  doResetDeletePropertyViewingPreferenceFailed: () => ({
    type: propertyActions.DO_RESET_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED
  }),

  DO_SAVE_LANDLORD_ENTITY_PREFERENCES: 'DO_SAVE_LANDLORD_ENTITY_PREFERENCES',
  DO_SAVE_LANDLORD_ENTITY_PREFERENCES_SUCCESS: 'DO_SAVE_LANDLORD_ENTITY_PREFERENCES_SUCCESS',
  DO_SAVE_LANDLORD_ENTITY_PREFERENCES_FAILED: 'DO_SAVE_LANDLORD_ENTITY_PREFERENCES_FAILED',
  doLandlordSaveEntityPreferences: response => ({
    type: propertyActions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES,
    payload: response
  }),
  doLandlordSaveEntityPreferencesSuccess: response => ({
    type: propertyActions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES_SUCCESS,
    payload: response
  }),
  doLandlordSaveEntityPreferencesFailed: response => ({
    type: propertyActions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES_FAILED,
    payload: response
  }),

  DO_RESET_LANDLORD_ENTITY_PREFERENCES_FAILED: 'DO_RESET_LANDLORD_ENTITY_PREFERENCES_FAILED',
  doLandlordResetEntityPreferencesFailed: () => ({
    type: propertyActions.DO_RESET_LANDLORD_ENTITY_PREFERENCES_FAILED
  }),

  DO_ADD_PROPERTY_VIEWING_PREFERENCE: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE',
  DO_ADD_PROPERTY_VIEWING_PREFERENCE_SUCCESS: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE_SUCCESS',
  DO_ADD_PROPERTY_VIEWING_PREFERENCE_FAILED: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE_FAILED',
  doAddPropertyViewingPreference: payload => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE,
    payload
  }),
  doAddPropertyViewingPreferenceSuccess: response => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SUCCESS,
    payload: response
  }),
  doAddPropertyViewingPreferenceFailed: response => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_FAILED,
    payload: response
  }),

  DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE',
  DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS',
  DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED: 'DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED',
  doAddPropertyViewingPreferenceSingle: payload => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE,
    payload
  }),
  doAddPropertyViewingPreferenceSingleSuccess: response => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS,
    payload: response
  }),
  doAddPropertyViewingPreferenceSingleFailed: response => ({
    type: propertyActions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED,
    payload: response
  }),

  DO_GET_PROPERTY_LISTING_PRICE: 'DO_GET_PROPERTY_LISTING_PRICE',
  DO_GET_PROPERTY_LISTING_PRICE_SUCCEEDED: 'DO_GET_PROPERTY_LISTING_PRICE_SUCCEEDED',
  doGetPropertyListingPrice: response => ({
    type: propertyActions.DO_GET_PROPERTY_LISTING_PRICE,
    payload: response
  }),
  doGetPropertyListingPriceSucceeded: response => ({
    type: propertyActions.DO_GET_PROPERTY_LISTING_PRICE_SUCCEEDED,
    payload: response
  }),

  DO_MAKE_STRIPE_ADVERTISE_PAYMENT: 'DO_MAKE_STRIPE_ADVERTISE_PAYMENT',
  DO_MAKE_STRIPE_ADVERTISE_PAYMENT_SUCCEEDED: 'DO_MAKE_STRIPE_ADVERTISE_PAYMENT_SUCCEEDED',
  doMakeStripeAdvertisePayment: response => ({
    type: propertyActions.DO_MAKE_STRIPE_ADVERTISE_PAYMENT,
    payload: response
  }),
  doMakeStripeAdvertisePaymentSucceeded: response => ({
    type: propertyActions.DO_MAKE_STRIPE_ADVERTISE_PAYMENT_SUCCEEDED,
    payload: response
  }),

  DO_ADD_PROPERTY_TO_PORTAL_QUEUE: 'DO_ADD_PROPERTY_TO_PORTAL_QUEUE',
  doAddPropertyToPortalQueue: payload => ({
    type: propertyActions.DO_ADD_PROPERTY_TO_PORTAL_QUEUE,
    payload: payload
  }),

  DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE: 'DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE',
  doRemovePropertyFromPortalQueue: payload => ({
    type: propertyActions.DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE,
    payload: payload
  }),

  DO_PORTAL_QUEUE_REMOVED: 'DO_PORTAL_QUEUE_REMOVED',
  doPortalQueueRemoved: () => ({
    type: propertyActions.DO_PORTAL_QUEUE_REMOVED
  }),

};
export default propertyActions;



// WEBPACK FOOTER //
// ./src/redux/propertiesAdvertise/actions.js